import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";

import { useIsBroker } from "@/auth/roles";
import { homepageRoute } from "@/routing";
import { setSearchType } from "@/state/searchInputSlice";
import { clearCurrentSearch } from "@/state/currentSearchSlice";
import {
    AnalyticsCta,
    AnalyticsToolbar,
    MetricCard,
    RequestAccessBanner,
    sampleRevenuePerTruck,
} from "@/components/dataPages/brokerAnalytics";

// Broker-only preview of company analytics. Everything on the page runs on sample data
// (see brokerAnalyticsSampleData.js); "Request access" is the path to the real thing.
export const BrokerAnalytics = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const canAccess = useIsBroker();
    const [period, setPeriod] = useState("WoW");

    useEffect(() => {
        dispatch(setSearchType("broker_analytics"));
        dispatch(clearCurrentSearch());
    }, [dispatch]);

    useEffect(() => {
        if (!canAccess) {
            navigate(homepageRoute, { replace: true });
        }
    }, [canAccess, navigate]);

    if (!canAccess) return null;

    const revenuePerTruck = sampleRevenuePerTruck[period];

    return (
        <div className="mx-auto flex w-full max-w-[1132px] flex-col gap-4 pb-16">
            <RequestAccessBanner />
            <AnalyticsToolbar period={period} onPeriodChange={setPeriod} className="mt-[19px]" />
            <div className="grid gap-x-4 gap-y-2 md:grid-cols-2">
                <MetricCard title="Gross revenue per load" metric={revenuePerTruck.metric} yTicks={revenuePerTruck.yTicks} />
                <MetricCard
                    title="Pick any metric"
                    badge="configurable"
                    metric={revenuePerTruck.metric}
                    yTicks={revenuePerTruck.yTicks}
                    skeleton
                />
            </div>
            <AnalyticsCta className="mt-8" />
        </div>
    );
};
